import React from 'react';

interface CheckboxProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  error?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  label,
  checked,
  onChange,
  disabled = false,
  error,
}) => {
  return (
    <div>
      <div className="flex items-center">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          className={`
            h-5 w-5 rounded border-gray-300 text-primary focus:ring-primary
            ${disabled ? 'opacity-60 cursor-not-allowed' : ''}
            ${error ? 'border-red-500' : ''}
          `}
        />
        <label
          htmlFor={id}
          className={`ml-2 block text-sm text-gray-700 ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}
        >
          {label}
        </label>
      </div>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default Checkbox; 